export default "__VITE_ASSET__CPX8wBww__"